import { CheckCircle2 } from 'lucide-react';

const COMPARISON_ROWS = [
  { feature: '24/7 Network Monitoring', basic: true, standard: true, premium: true },
  { feature: 'Help Desk Support', basic: 'Business Hours', standard: 'Extended', premium: '24/7' },
  { feature: 'Response SLA', basic: '4 hours', standard: '1 hour', premium: '15 min' },
  { feature: 'Endpoint Protection', basic: 'Basic', standard: 'Advanced (EDR)', premium: 'Advanced (EDR)' },
  { feature: 'Email Security', basic: false, standard: true, premium: true },
  { feature: 'Patch Management', basic: false, standard: true, premium: true },
  { feature: 'Security Training', basic: false, standard: true, premium: true },
  { feature: 'Backup & DR', basic: false, standard: false, premium: true },
  { feature: 'vCIO / Consulting', basic: false, standard: false, premium: true },
  { feature: 'On-Site Visits', basic: 'Add-on', standard: 'Add-on', premium: '2/month' },
];

function CellValue({ value }) {
  if (typeof value === 'boolean') {
    if (value) return <CheckCircle2 className="w-5 h-5 text-blue-600 mx-auto" />;
    return <span className="text-slate-300">&mdash;</span>;
  }
  return <span className="text-sm text-slate-600">{value}</span>;
}

export function ComparisonTable() {
  return (
    <section className="py-20 bg-white" data-testid="comparison-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-black text-slate-900 mb-4" style={{ fontFamily: 'Chivo, sans-serif' }}>
            What's Included in Each Plan
          </h2>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full border-collapse" data-testid="comparison-table">
            <thead>
              <tr className="border-b border-slate-200">
                <th className="text-left py-4 px-4 font-semibold text-slate-900">Feature</th>
                <th className="text-center py-4 px-4 font-semibold text-slate-900">Basic</th>
                <th className="text-center py-4 px-4 font-semibold text-blue-600 bg-blue-50">Standard</th>
                <th className="text-center py-4 px-4 font-semibold text-slate-900">Premium</th>
              </tr>
            </thead>
            <tbody>
              {COMPARISON_ROWS.map((row) => (
                <tr key={row.feature} className="border-b border-slate-100">
                  <td className="py-4 px-4 text-slate-700">{row.feature}</td>
                  <td className="text-center py-4 px-4"><CellValue value={row.basic} /></td>
                  <td className="text-center py-4 px-4 bg-blue-50"><CellValue value={row.standard} /></td>
                  <td className="text-center py-4 px-4"><CellValue value={row.premium} /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
